export class CarModelSinister {
    id: number;
    assistance_sale_id: number;
    car_model_id: number;
    car_color: number;
    car_plate: string;
    car_year: string;
    brand_description: string;
    model_description: string;
    type_description: string;
    color_description:string;
    serial_number:string;
    engine_number:string;
  
  constructor() {
    this.car_plate = ""
    this.car_year = ""
    this.brand_description = ""
    this.model_description = ""
    this.type_description = ""
    this.color_description = ""
    this.serial_number = ""
    this.engine_number = ""
  }
}